// RejectTravelDialog.js
import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';

const RejectTravelDialog = ({ visible, onHide, onSubmit }) => {
    const [reason, setReason] = useState('');


    const handleReject = () => {
        if (reason?.trim()) {
            onSubmit(reason);
            setReason('');
            onHide(); // Close the dialog after submission
        } else {
            alert('Please enter a reason for rejection.');
        }
    };

    return (
        <Dialog header="Reject Travel Request" visible={visible} onHide={onHide} style={{ width: '30vw' }}>
            <div className="p-field">
                {/* <label htmlFor="reason">Reason</label> */}
                <InputTextarea id="reason" value={reason} onChange={(e) => setReason(e.target.value)} rows={5} cols={30} />
            </div>
            <div className="p-d-flex p-jc-end">
                <Button label="Cancel" icon="pi pi-times" onClick={onHide} className="p-button-text p-mr-2" />
                <Button label="Submit" icon="pi pi-check" onClick={handleReject} autoFocus />
            </div>
        </Dialog>
    );
};

export default RejectTravelDialog;
